import React, { useState, useEffect } from 'react';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  Typography, 
  Box,
  Button,
  CircularProgress,
  Alert
} from '@mui/material';
import { getTransactions } from 'helpers/dao.lib';

const TransactionsTab = ({ daoId, daoInfo, daoCodebases }) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState(null);
  const [syncMessage, setSyncMessage] = useState('');

  const loadTransactions = async () => {
    setLoading(true);
    setError(null);
    try {
      // Sử dụng API mới để lấy tất cả transactions của DAO
      const res = await getTransactions({ daoId });
      if (res?.data?.data?.transactions) {
        setTransactions(res.data.data.transactions);
      } else {
        setTransactions([]);
      }
    } catch (err) {
      console.error('Error loading transactions:', err);
      setError('Failed to load transactions');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (daoId) {
      loadTransactions();
    }
  }, [daoId]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" sx={{ color: '#00EDC3', mb: 3 }}>
        Codebase Transactions
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {syncMessage && (
        <Alert severity="info" sx={{ mb: 2 }}>
          {syncMessage}
        </Alert>
      )}

      {transactions.length === 0 ? (
        <Paper sx={{ p: 3, textAlign: 'center', backgroundColor: '#2A2E33' }}>
          <Typography variant="body1" sx={{ color: '#F4F4F4' }}>
            No transactions found for this DAO's codebases.
          </Typography>
        </Paper>
      ) : (
        <TableContainer component={Paper} sx={{ backgroundColor: '#2A2E33' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ color: '#00EDC3', fontWeight: 600 }}>NFT ID</TableCell>
                <TableCell sx={{ color: '#00EDC3', fontWeight: 600 }}>Solution Name</TableCell>
                <TableCell sx={{ color: '#00EDC3', fontWeight: 600 }}>Buyer Wallet</TableCell>
                <TableCell sx={{ color: '#00EDC3', fontWeight: 600 }}>Production Partner Email</TableCell>
                <TableCell sx={{ color: '#00EDC3', fontWeight: 600 }}>Amount</TableCell>
                <TableCell sx={{ color: '#00EDC3', fontWeight: 600 }}>Purchase Date</TableCell>
                <TableCell sx={{ color: '#00EDC3', fontWeight: 600 }}>Status</TableCell>
                <TableCell sx={{ color: '#00EDC3', fontWeight: 600 }}>Transaction Hash</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transactions.map((tx, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ color: '#F4F4F4' }}>{tx.nftId}</TableCell>
                  <TableCell sx={{ color: '#F4F4F4' }}>
                    {tx.solutionName || 'N/A'}
                  </TableCell>
                  <TableCell sx={{ color: '#F4F4F4' }}>
                    {tx.buyerAddress || 'N/A'}
                  </TableCell>
                  <TableCell sx={{ color: '#F4F4F4' }}>
                    {tx.buyerEmail || 'N/A'}
                  </TableCell>
                  <TableCell sx={{ color: '#F4F4F4' }}>
                    {tx.amount || tx.paidAmount || 'N/A'}
                  </TableCell>
                  <TableCell sx={{ color: '#F4F4F4' }}>{tx.purchaseDate ? new Date(tx.purchaseDate).toLocaleString() : ''}</TableCell>
                  <TableCell sx={{ color: '#F4F4F4' }}>{tx.transactionStatus}</TableCell>
                  <TableCell sx={{ color: '#F4F4F4' }}>
                    {tx.transactionHash ? (
                      <a 
                        href={tx.transactionHashUrl || `https://polygonscan.com/tx/${tx.transactionHash}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#00EDC3', textDecoration: 'none' }}
                      >
                        {tx.transactionHash.substring(0, 10)}...
                      </a>
                    ) : (
                      'N/A'
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default TransactionsTab; 